import '../scss/component-show-more-content.scss';

export class ShowMoreContent extends HTMLElement {
  constructor() {
    super();

    const buttonToggle = this.querySelector('.product__showmore__indicator');

    if (this.querySelector('.content-truncated').offsetHeight >= 60) {
      this.truncate();
      this.hide();
    }
    buttonToggle.addEventListener('click', () => {
      this.toggle();
    });
  }

  toggle() {
    if (this.classList.contains('hide')) {
      this.show();
    } else {
      this.hide();
    }
  }

  truncate() {
    this.classList.add('truncate');
  }

  show() {
    this.classList.remove('hide');
  }

  hide() {
    this.classList.add('hide');
  }
}
customElements.define('show-more-content', ShowMoreContent);
